import { fetchCaptcha } from "./api";
import { ECaptchaConstant } from "../../constants";
import { CaptchaImageStorage } from "../getCaptchaImage/data";
export var refreshCaptcha = function refreshCaptcha() {
  var imageStorage = CaptchaImageStorage.getInstance();
  var _imageStorage$getData = imageStorage.getData(),
    key = _imageStorage$getData.key;
  return fetchCaptcha({
    height: ECaptchaConstant.DefaultCaptchaHeight,
    width: ECaptchaConstant.DefaultCaptchaWidth,
    key: key
  }).then(function (data) {
    imageStorage.initialize({
      image: data.captcha,
      key: data.key
    });
  }).catch(function (e) {
    console.error(e);
    imageStorage.initialize({
      image: undefined,
      key: undefined
    });
  });
};